import { render, staticRenderFns } from "./VerticalNavMenuGroupLink.vue?vue&type=template&id=1a649b31"
import script from "./VerticalNavMenuGroupLink.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuGroupLink.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuGroupLink.vue?vue&type=style&index=0&id=1a649b31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports